<template>
  <div class="containerMod">
    <div class="Blk-SelEst">
      <select class="estadoHead" name="estados" id="" v-model="idiomaSel.idioma" label= "Hola">
        <option v-for="idioma in idiomas"
          :key="idioma"
          :value="idioma.idioma">
          {{idioma.idioma}}
        </option>
      </select>
    </div>
    <div class="lista">
      <div v-if="loading" class="loading-container">
        <div class="loader"></div>
      </div>
      <div v-else>
        <div class="bloqueFicha" v-for="(palabra1, index) in filtroIdiomas" :key="index">
          <div class="eti">
            <div class="abreviatura">
              {{palabra1.palabra}}
            </div>
          </div>
          <div class="content">
            <div v-for="(bloque1, index) in bloquesTr" :key="index">
              <div v-if="bloque1.bloqueTr === palabra1.bloque">
                <div class="tabla" v-for="(pareja, index) in bloque1.pareja" :key="index">
                  <p class="campoId" id="idioma">{{pareja.idioma}}</p>
                  <p class="campoPal">{{pareja.palabra}}</p>
                </div>
                <!-- <div class="comment">{{bloque1.comment}}</div> -->
              </div>
            </div>
          </div>
          <div class="comment">
            <div>
              {{comments.find(e => e.bloque === palabra1.bloque).comentario}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowDiccionario',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getComments()
    this.getPalabras()
    this.getIdiomas()
    // this.idiomaSel.idioma = 'Español'
    this.$emit('scrollHidden')
  },
  emits: ['scrollHidden', 'NoScrollHidden'],
  data () {
    return {
      idiomas: [],
      idiomaSel: { idioma: 'Español' },
      palabras: [],
      bloquesTr: [],
      comments: [],
      URLbase: '',
      loading: false,
      orden: 0,
      objeto: 'idioma'
    }
  },
  methods: {
    async getIdiomas () { //
      try {
        const url = `${this.URLbase}/idiomas/listIdiomas`
        const res = await fetch(url)
        this.idiomas = await res.json()
        this.loading = false
      } catch (error) {
        alert(error)
        this.loading = false
      }
    },
    async getComments () { //
      try {
        this.loading = true
        const url = `${this.URLbase}/comments/listComments`
        const res = await fetch(url)
        this.comments = await res.json()
      } catch (error) {
        alert(error)
        this.loading = false
      }
    },
    async getPalabras () {
      try {
        const url = `${this.URLbase}/palabras/listPalabras`
        const res = await fetch(url)
        this.palabras = await res.json()
      } catch (error) {
        alert(error)
        this.loading = false
      }
      this.creaBlksTr2()
    },
    creaBlksTr2 () {
      var bloqueInd
      var idioRep
      this.palabras.forEach(e => {
        const obj = { palabra: e.palabra, idioma: e.idioma }
        const array = [obj]
        bloqueInd = this.bloquesTr.findIndex(block => block.bloqueTr === e.bloque)
        if (bloqueInd < 0) {
          this.bloquesTr.push({ bloqueTr: e.bloque, pareja: array })
        } else {
          idioRep = this.bloquesTr[bloqueInd].pareja.findIndex(par => par.idioma === e.idioma)
          if (idioRep < 0) {
            this.bloquesTr[bloqueInd].pareja.push(obj)
          } else {
            let pal = this.bloquesTr[bloqueInd].pareja[idioRep].palabra
            pal = pal + ', ' + e.palabra
            this.bloquesTr[bloqueInd].pareja[idioRep].palabra = pal
          }
        }
      })
      // this.bloquesTr.forEach(e => {
      //   const com = this.comments.find(elemento => elemento.bloque === e.bloqueTr).comentario
      //   e.comment = com
      // })
    }
  },
  computed: {
    filtroIdiomas () {
      if (this.idiomaSel.idioma === 'Todos') {
        return this.palabras
      } else {
        return this.palabras.filter(c => c.idioma === this.idiomaSel.idioma)
      }
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerMod{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}
.Blk-SelEst{
  display: flex;
  /* border: solid 0.5px rgb(76, 248, 2); */
  height: 8%;
  justify-content:flex-end;
  align-items: center;
  background-color: var(--gr-fo-for);
  margin-top: 3px;
}
.estadoHead{
  height: 78%;
  width: 30%;
  border: var(--bo-cam);
  border-radius: 3px;
  color: var(--tx-cam);
  font-weight: 600;
  font-size: 16px;
  margin-right: 3%;
}
.lista {
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  margin-top: 3px;
  background-color: var(--gr-fo-for);
  color:rgb(2, 2, 2);
  /* border: solid 0.5px rgb(235, 3, 247); */
}
.bloqueFicha{
  width: 100%;
  height: auto;
  margin-top: 10px;
  padding-bottom: 10px;
  display: flex;
  align-items: stretch;
  border-bottom: solid 0.5px rgb(136, 166, 180);
}
.eti{
  width: 220px;
}
.abreviatura{
  font-size: 105%;
  font-weight: 700;
  color: rgb(30, 119, 161);
  background-color: white;
  border: solid 1px gray;
  box-shadow: none;
  margin: 0px 8%;
  padding-bottom:2px;
}
.content{
  width:400px;
  display: flex;
  flex-direction: row;
  /* align-items: flex-start; */
  padding-left: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
}
.tabla{
  /* width: 100%; */
  display:flex;
  /* border: solid 0.5px rgb(235, 3, 247); */
}
.campoPal{
  color: black;
  margin: 2px 2px;
  padding: 3px 25px;
  width: 240px;
  margin: 0;
  margin-bottom: 2px;
  padding: 2px 5px;
  background-color: rgb(189, 215, 224);
}
.campoId{
  width: 85px;
  color: black;
  padding: 3px 25px;
  margin-right: 0px;
  border: none;
  background-color: rgb(165, 201, 215);
  margin-bottom: 2px;
}
.comment{
  width: 235px;
  text-align: left;
  font-size: 90%;
  padding: 3px 10px;
  color : rgb(112, 112, 112);
  background-color: rgb(245, 245, 245);
}
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 900px){
  .eti{
    width: 27vw;
  }
  .content{
    width:38vw;
  }
  .comment{
    width: 30vw;
  }
  .campoId{
    width: 12vw;
    padding: 2px 5px;
  }
  .campoPal{
    width: 23vw;
    padding: 3px 2px;
  }
}
@media screen and (max-width: 576px){
  .Blk-SelOrd{
    display: flex;
    width: 100%;
  }
  .lista{
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .bloqueFicha{
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* background-color: var(--gr-fo-for);*/
    /* border-bottom: solid 0.5px rgb(136, 166, 180); */
    /* margin: 0; */
    /* padding: 0; */
  }
  .eti{
    margin: 0;
    justify-self: center;
    width: 100%;
    /* border: solid .5px rgb(250, 135, 4); */
  }
  .abreviatura{
    width: 99.7%;
    font-size: 100%;
    font-weight: 700;
    box-shadow: none;
    margin: 0;
    margin-bottom: 3px;
    padding-bottom:2px;
  }
  .content{
    width: 100%;
    flex-direction: column;
  }
  .campoPal{
    width: 65%;
    margin: 0;
    margin-bottom: 2px;
    padding: 2px 5px;
    font-size: 90%;
    background-color: rgb(189, 215, 224);
    border: none;
  }
  .campoId{
    width: 35%;
    margin: 0;
    padding: 2px 5px;
    font-size: 90%;
    margin-right: 0px;
    border: none;
    background-color: rgb(165, 201, 215);
    margin-bottom: 2px;
  }
  .containerEdiciones{
    width: 90%;
  }
  .bloqueEdicion{
    display: flex;
    flex-direction: column;
  }
  .estadoHead{
    height: 66%;
    width: 70vw;
    color: var(--tx-cam);
    font-size: 16px;
    margin-left: 8px;
  }
  .comment{
    width: 100%;
    font-size: 14px;
    padding: 0;
    margin: 7px 0;
    background-color: transparent;
    line-height: 1.25;
    font-size: 90%;
  }

}
</style>
